<template>
  <div>
    <el-row style="margin-top: 20px; padding-left: 5px">
      <el-col :sm="20">
        <div style="display: inline-block; margin-right: 10px">
          <strong style="font-size: 13px">{{ $t('select.shop') }}</strong><br>
          <el-select size="small" :placeholder="$t('select.shop')" v-model="shopee_shop.selected" filterable>
            <el-option-group :label="$t('shop.added')">
              <el-option v-for="item in shopee_shop.list.filter(i => !i.is_sub_account)" :key="item.username"
                         :label="`${item.username} ${item.name}`" :value="item._id">
                <div>
                  <table style="width:100%;">
                    <tbody>
                    <tr>
                      <td style="width:40px;">
                        <img style="width:28px; height:28px; border-radius: 50vh;"
                             :src="logo_channel(item.channel)"
                             alt="image">
                      </td>
                      <td style="padding-left:10px;">
                        {{ item.username }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-option>
            </el-option-group>
            <el-option-group :label="$t('shop.managed')">
              <el-option v-for="item in shopee_shop.list.filter(i => i.is_sub_account)" :key="item.username"
                         :label="`${item.username} ${item.name}`" :value="item._id">
                <div>
                  <table style="width:100%;">
                    <tbody>
                    <tr>
                      <td style="width:40px;">
                        <img style="width:28px; height:28px; border-radius: 50vh;"
                             :src="logo_channel(item.channel)"
                             alt="image">
                      </td>
                      <td style="padding-left:10px;">
                        {{ item.username }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div style="display: inline-block">
          <strong style="font-size: 13px">Chọn thời gian tham chiếu</strong><br>
          <el-select id="select-month" size="small" value="" placeholder="Chọn tháng" v-model="month"
                     @change="m__get_metrics()" filterable>
            <el-option v-for="item of months" :key="item" :value="item" :label="`Tháng ${item + 1}`"></el-option>
          </el-select>&nbsp;&nbsp;
          <el-select size="small" value="" placeholder="Chọn năm" v-model="year" @change="m__get_metrics()"
                     filterable>
            <el-option v-for="item of years" :key="item" :value="item" :label="item"></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :sm="4" class="text-right">
        <strong style="font-size: 13px">&nbsp;</strong><br>
        <el-button size="small" type="primary" icon="el-icon-s-order" @click="m__show_agency_file_dialog">
          Danh sách file Agency
        </el-button>
      </el-col>
    </el-row>

    <el-row style="margin-top: 30px; padding-left: 5px">
      <strong class="text-primary" style="font-size: 13px">Dữ liệu tham chiếu</strong>

      <el-row style="margin-top: 10px">
        <el-col :sm="3" style="margin-right: 15px">
          <strong>AOV Trung bình:</strong><br>
          <el-input type="number" size="mini" v-model="aov" placeholder="AOV Trung bình"></el-input>
        </el-col>
        <el-col :sm="3" style="margin-right: 15px">
          <strong>Số đơn hàng:</strong><br>
          <el-input type="number" size="mini" v-model="order" placeholder="Số đơn hàng"></el-input>
        </el-col>
        <el-col :sm="3" style="margin-right: 15px">
          <strong>Traffic / Lượt click:</strong><br>
          <el-input type="number" size="mini" v-model="traffic" placeholder="Traffic / Lượt click"></el-input>
        </el-col>
        <el-col :sm="3" style="margin-right: 15px">
          <strong>CR (%):</strong><br>
          <el-input type="number" size="mini" v-model="cr" placeholder="CR"></el-input>
        </el-col>
        <el-col :sm="3" style="margin-right: 15px">
          <strong>GMV:</strong><br>
          <el-input type="number" size="mini" v-model="gmv" placeholder="CR"></el-input>
        </el-col>
        <el-col :sm="3" style="margin-right: 15px">
          <strong>GMV Ads:</strong><br>
          <el-input type="number" size="mini" v-model="gmv_ads" placeholder="CR"></el-input>
        </el-col>
        <el-col :sm="3" style="margin-right: 15px">
          <strong>Chi phí Ads:</strong><br>
          <el-input type="number" size="mini" v-model="cost_ads" placeholder="CR"></el-input>
        </el-col>
      </el-row>

      <el-row style="margin-top: 15px">
        <strong style="color: grey">
          Chi phí Ads / GMV Ads: <span
          class="text-danger">{{ +gmv_ads ? (cost_ads * 100 / gmv_ads).toFixed(2) : '0.00' }} %</span>
        </strong>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong style="color: grey">
          Chi phí Ads / GMV: <span class="text-danger">{{
            +gmv ? (cost_ads * 100 / gmv).toFixed(2) : '0.00'
          }} %</span>
        </strong>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong style="color: grey">
          GMV Ads / GMV: <span class="text-danger">{{ +gmv ? (gmv_ads * 100 / gmv).toFixed(2) : '0.00' }} %</span>
        </strong>
      </el-row>
    </el-row>

    <el-row style="margin-top: 30px; padding-left: 5px">
      <strong class="text-primary" style="font-size: 13px">Thông tin kỳ vọng</strong>

      <el-row style="margin-top: 10px">
        <el-col :sm="3" style="margin-right: 15px">
          <strong>Chọn tháng:</strong><br>
          <el-select size="mini" v-model="expected_month" class="full-w" placeholder="Chọn tháng" value filterable>
            <el-option v-for="item in expected_months" :key="item" :value="item" :label="`Tháng ${item + 1}`"></el-option>
          </el-select>
        </el-col>
        <el-col :sm="3" style="margin-right: 15px">
          <strong>GMV kỳ vọng:</strong><br>
          <el-input type="number" size="mini" v-model="expected_gmv" placeholder="Doanh thu kỳ vọng"></el-input>
          <small class="text-danger">GMV: {{ expected_gmv | format_currency }}</small>
        </el-col>
        <el-col :sm="3" style="margin-right: 15px">
          <strong>Chi phí kỳ vọng:</strong><br>
          <el-input type="number" size="mini" v-model="expected_cost" placeholder="Chi phí kỳ vọng"
                    @keyup.enter.native="m__generate_data()"></el-input>
          <small class="text-danger">Chi phí Ads: {{ m__calculate_expected_cost() | format_currency }}</small>
        </el-col>
        <el-col :sm="3" style="margin-right: 15px">
          <strong>&nbsp;</strong><br>
          <el-select style="width: 130px" class="full-w" size="mini" v-model="expected_cost_type" value filterable>
            <el-option value="cost" label="Theo giá tiền"></el-option>
            <el-option value="percent" label="Theo phần trăm"></el-option>
          </el-select>
        </el-col>
      </el-row>
    </el-row>

    <el-row style="margin-top: 30px; padding-left: 5px">
      <br>
      <el-row>
        <el-col :sm="20">
          <el-button size="mini" @click="m__use_aov">Sử dụng AOV tham chiếu</el-button>
          <el-button size="mini" @click="m__use_cr">Sử dụng CR tham chiếu</el-button>
          <el-button size="mini" icon="el-icon-files" @click="m__show_agency_filename_dialog">Lưu file</el-button>
        </el-col>
        <el-col :sm="4" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" @click="m__generate_data"
                     :loading="loading.generate_data">
            Tạo dữ liệu chi tiết
          </el-button>
        </el-col>
      </el-row>

      <el-table style="margin-top: 10px" :data="data" :row-class-name="m__cell_class_name"
                :cell-class-name="m__cell_style" :header-cell-class-name="m__header_style"
                v-loading="loading.generate_data">
        <el-table-column label="Kênh marketing" width="200px" prop="name"></el-table-column>
        <el-table-column :label="$t('base.sales')" align="center">
          <el-table-column label="Tỉ lệ" align="center" min-width="140px" prop="gmv_percent">
            <template slot-scope="scope">
              <el-input type="number" class="invisible-input" size="mini" v-model="scope.row.gmv_percent"
                        @input="m__on_change('gmv', scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="Số tiền" align="center" min-width="140px">
            <template slot-scope="scope">
              {{ scope.row.gmv | format_currency }}
              <!--              <el-input class="invisible-input" size="mini" v-model="scope.row.gmv"></el-input>-->
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('metric.expense')" align="center">
          <el-table-column label="Tỉ lệ" align="center" min-width="140px" prop="cost_percent">
            <template slot-scope="scope">
              <el-input type="number" class="invisible-input" size="mini" v-model="scope.row.cost_percent"
                        @input="m__on_change('cost', scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="Số tiền" align="center" min-width="140px">
            <template slot-scope="scope">
              {{ scope.row.cost | format_currency }}
              <!--              <el-input class="invisible-input" size="mini" v-model="scope.row.cost"></el-input>-->
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="AOV" min-width="140px" prop="aov">
          <template slot-scope="scope">
            <el-input type="number" class="invisible-input" size="mini" v-model="scope.row.aov"
                      @input="m__on_change('aov', scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="Order" min-width="140px">
          <template slot-scope="scope">
            <!--            <el-input class="invisible-input" size="mini" v-model="scope.row.order"></el-input>-->
            {{ scope.row.order | format_currency }}
          </template>
        </el-table-column>
        <el-table-column label="CR" min-width="140px">
          <template slot-scope="scope">
            <el-input type="number" class="invisible-input" size="mini" v-model="scope.row.cr"
                      @input="m__on_change('cr', scope.row)"></el-input>
            <!--            {{ scope.row.cr }}%-->
          </template>
        </el-table-column>
        <el-table-column label="Traffic / Click" min-width="140px">
          <template slot-scope="scope">
            <!--            <el-input class="invisible-input" size="mini" v-model="scope.row.traffic"></el-input>-->
            {{ scope.row.traffic }}
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="show_dialog.create_agency_filename"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.filename') }}</p>
        <el-input v-model="filename" size="mini" placeholder="Nhập tên file..."></el-input>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__save_agency_file"
                     :loading="loading.save_file">Lưu file dữ liệu
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="1000px" :close-on-click-modal="false" :visible.sync="show_dialog.agency_file"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 13px">Danh sách file Agency</strong>
        <el-table
          :data="agency_files.filter(i => $store.state.userInfo.username ==='vuducminhdev07' ? true : i.mipeeUserId === $store.state.userInfo.username)">
          <el-table-column :label="$t('base.filename')" prop="filename"></el-table-column>
          <el-table-column :label="$t('base.month')" prop="month" width="100px">
            <template slot-scope="scope">
              {{ `${scope.row.month + 1}/${scope.row.year}` }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.shop')" width="150px">
            <template slot-scope="scope">
              {{ m__get_shop_name(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.action')" width="200px">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="m__use_agency_file(scope.row)" :loading="scope.row.loading">
                <strong class="text-info">{{ $t('base.use_file') }}</strong></el-button>
              <el-button type="text" size="mini" @click="m__delete_agency_file(scope.row)">
                <strong class="text-danger">Xoá</strong></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import {get_shop_mixins} from '../../mixins/get_shop';

export default {
  name: 'page__agency_plan_target',

  mixins: [get_shop_mixins],

  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').focus()
      }
    }
  },

  data() {
    return {
      seller: null,
      years: [],
      year: this.dayjs().year(),
      months: [],
      month: null,
      data: [],

      aov: null,
      order: null,
      traffic: null,
      cr: null,
      gmv: null,
      gmv_ads: null,
      cost_ads: null,

      expected_months: [],
      expected_month: null,
      expected_gmv: null,
      expected_gmv_ads: null,
      expected_cost: null,
      expected_cost_type: 'cost',

      filename: '',
      agency_files: [],

      show_dialog: {
        agency_file: false
      },
      loading: {
        generate_data: false,
        save_file: false
      }
    }
  },

  async beforeMount() {
    this.years = []
    for (let i = this.dayjs().year(); i >= this.dayjs().year() - 2; i--) {
      this.years.push(i)
    }

    this.months = []
    const end_month = this.year >= this.dayjs().year() ? this.dayjs().month() + 1 : 12
    for (let i = 0; i < end_month; i++) {
      this.months.push(i)
    }
    this.month = this.dayjs().month() - 1

    this.expected_months = []
    for (let i = 0; i < 12; i++) {
      this.expected_months.push(i)
    }
    this.expected_month = this.dayjs().month()

    await this.m__get_shopee_shop()
    await this.m__get_agency_file()
  },

  watch: {
    'shopee_shop.selected': function () {
      this.m__initial_view()
    }
  },

  methods: {
    m__show_agency_filename_dialog() {
      if (!this.data.length) {
        return
      }

      this.filename = `Kế hoạch chi tiết Tháng ${this.expected_month + 1}/${this.dayjs().year()} - ${this.dayjs().format('DDMMHHmm')}`
      this.show_dialog.create_agency_filename = true
    },

    async m__save_agency_file() {
      if (!this.data.length) {
        return
      }

      if (!this.filename) {
        this.ntf_w(this.$t('required.filename'))
      }

      this.loading.save_file = true
      try {
        await this.$http.post(this.API.URL_API_SRV_1 + '/agency_target_file', {
          mipeeUserId: this.$store.state.userInfo.username,
          shopId: this.shopee_shop.selected,
          filename: this.filename,
          month: this.month,
          year: this.year,
          expectedMonth: this.expected_month,
          expectedGmv: this.expected_gmv,
          expectedGmvAds: this.expected_gmv_ads,
          expectedCost: this.expected_cost,
          expectedType: this.expected_cost_type,
          data: JSON.stringify(this.data)
        }, this.cf())
        await this.m__get_agency_file()

        this.show_dialog.create_agency_filename = false
        this.ntf_s('Tạo file thành công')
        this.counter++
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.save_file = false
      }
    },

    m__get_shop_name(file) {
      const shop_found = this.shopee_shop.list.find(i => i._id === file.shopId)
      return shop_found ? shop_found.username : ''
    },

    m__show_agency_file_dialog() {
      this.show_dialog.agency_file = true
    },

    async m__use_agency_file(file) {
      file.loading = true
      try {
        if (this.shopee_shop.list.find(i => i._id === file.shopId)) {
          this.month = file.month
          this.year = file.year
          this.expected_month = file.expectedMonth
          this.expected_gmv = file.expectedGmv
          this.expected_gmv_ads = file.expectedGmvAds
          this.expected_cost = file.expectedCost
          this.shopee_shop.selected = file.shopId
          await this.m__initial_view()
          this.data = JSON.parse(file.data)

          this.show_dialog.agency_file = false
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        file.loading = false
      }
    },

    async m__delete_agency_file(file) {
      try {
        await this.$confirm('Bạn có muốn xoá file agency này không?', this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })

        await this.$http.delete(this.API.URL_API_SRV_1 + '/agency_target_file', {
          ...this.cf(),
          params: {
            fileId: file.id,
            mipeeUserId: this.$store.state.userInfo.username
          }
        })
        await this.m__get_agency_file()
        this.ntf_s('Xoá file thành công')
      } catch (e) {
      }
    },

    async m__get_agency_file() {
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_target_file/all', {
        ...this.cf(),
        params: {mipeeUserId: this.$store.state.userInfo.username}
      })
      for (const item of resp.body) {
        item.loading = false
      }
      this.agency_files = resp.body.filter(i => this.$store.state.userInfo.username === 'vuducminhdev07' ? true : this.shopee_shop.list.some(ii => ii._id === i.shopId))
    },

    m__use_aov() {
      if (+this.aov) {
        for (const item of this.data) {
          item.aov = this.aov
          if (+item.aov) item.order = Math.floor(item.gmv / item.aov)
          if (+item.cr) item.traffic = Math.floor(+item.order * 100 / +item.cr)
        }
      }
    },

    m__use_cr() {
      if (+this.cr) {
        for (const item of this.data) {
          item.cr = this.cr
          if (+item.cr) item.traffic = Math.floor(+item.order * 100 / +item.cr)
        }
      }
    },

    m__header_style({column}) {
      if (['Tỉ lệ', 'AOV', 'Doanh thu', 'Chi phí'].includes(column.label) || column.label.includes('Số liệu tham khảo')) {
        return 'cell-style'
      }
    },

    m__cell_style({column}) {
      if (['gmv_percent', 'cost_percent', 'aov'].includes(column.property)) {
        return 'cell-style'
      }
    },

    m__cell_class_name({row}) {
      if (!row.parent) {
        return 'parent-row no-hover'
      }

      return 'no-hover'
    },

    m__calculate_expected_cost() {
      if (!this.expected_cost) {
        return 0
      }

      if (this.expected_cost_type === 'cost') {
        return this.expected_cost
      } else {
        return this.expected_gmv * this.expected_cost / 100
      }
    },

    async m__initial_view() {
      let items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)

      try {
        if (this.shopee_shop.selected.length > 6) {
          if (items.length > 0) {
            let item = items[0]
            this.shop = item
            this.seller = await this.init_seller(item)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              return
            }

            this.data = []
            await this.m__get_metrics()

            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      } finally {
      }
    },

    async m__get_metrics() {
      const select_month = document.getElementById('select-month')
      if (this.month === null && select_month) {
        this.$nextTick(() => {
          select_month.focus()
        })
      }

      if (!this.shopee_shop.selected || this.month === null || this.year === null) {
        return
      }

      const start_time = this.dayjs([this.year, this.month]).startOf('month')
      const end_time = this.dayjs([this.year, this.month]).endOf('month')
      const resp = await this.seller.marketing_homepage_report_by_time(start_time.toDate(), end_time.toDate(), '[0,1,2,3,4,5,8]')
      if (!resp || !resp.data || !resp.data.data) {
        this.metrics_ads = {}
        this.aov = this.order = this.traffic = this.cr = null
        return
      }

      const metrics_ads = {}
      for (const item of resp.data.data.homepage_report) {
        for (const key of Object.keys(item)) {
          if (metrics_ads[key]) {
            metrics_ads[key] += +item[key]
          } else {
            metrics_ads[key] = +item[key]
          }
        }
      }
      this.metrics_ads = metrics_ads
      this.reports = resp.data.data.homepage_report

      const end_time_clone = end_time.isSameOrAfter(this.dayjs(), 'd') ? this.dayjs().startOf('d') : end_time.clone().add(1, 'd').startOf('d')
      const metrics_resp = await this.seller.dashboard__key_metrics(start_time.unix(), end_time_clone.unix(), 'month')
      const key_metrics = this.key_metrics = metrics_resp.result

      this.aov = Math.floor(key_metrics.place_sales_per_order.value)
      this.order = +key_metrics.place_orders.value
      this.traffic = +key_metrics.shop_uv.value
      this.cr = +key_metrics.shop_uv.value ? +(this.order * 100 / this.traffic).toFixed(2) : 0.00
      this.gmv = +key_metrics.place_gmv.value
      this.gmv_ads = Math.floor(metrics_ads.broad_gmv)
      this.cost_ads = Math.floor(metrics_ads.cost)
    },

    m__on_change(key, row) {
      if (key === 'gmv') {
        row.gmv = +this.expected_gmv ? row.gmv_percent * this.expected_gmv / 100 : 0
      }
      if (key === 'cost') {
        row.cost = +this.expected_cost ? row.cost_percent * this.expected_cost / 100 : 0
      }

      if (!row.parent) {
        for (const child of this.data.filter(i => i.parent === row.type)) {
          this.m__on_change(key, child)
        }
      }

      if (key === 'gmv' || key === 'aov') {
        for (const item of this.data) {
          if (+item.aov) item.order = Math.floor(item.gmv / item.aov)
          if (+item.cr) item.traffic = Math.floor(+item.order * 100 / +item.cr)
        }
      }

      if (key === 'cr') {
        if (+row.cr) row.traffic = Math.floor(+row.order * 100 / +row.cr)
      }
    },

    async m__generate_data() {
      if (!this.shopee_shop.selected || this.month === null) {
        return
      }

      if (!this.expected_month) {
        this.ntf_w('Vui lòng chọn tháng')
        return
      }

      if (this.expected_cost_type === 'percent') {
        this.expected_cost = Math.floor(this.expected_gmv * this.expected_cost / 100)
        this.expected_cost_type = 'cost'
      }

      this.loading.generate_data = true
      this.data = []

      const headers = [
        // {name: 'Nội sàn', type: 'internal', parent: ''},
        // {name: 'Ads Shopee', type: 'internal', parent: 'internal'},
        // {name: 'Shopee Live', type: 'internal', parent: 'internal'},
        // {name: 'Flash Sale', type: 'internal', parent: 'internal'},
        //
        // {name: 'Ngoại sàn', type: 'external', parent: ''},
        // {name: 'Book KOL/KOC', type: 'external', parent: 'external'},
        // {name: 'Ads', type: 'external', parent: 'external'},
        //
        // {name: 'Khác', type: 'other', parent: ''},
        // {name: 'Marketing Tool', type: 'other', parent: 'other'},
        // {name: 'Quà tặng', type: 'other', parent: 'other'},
        // {name: 'Seeding', type: 'other', parent: 'other'}
      ]

      const extend = ['Shopee Ads', 'Facebook Ads', 'Booking Group', 'Voucher Tung Group', 'Voucher Shop', 'Gift', 'Tiktok', 'Shopee Live', 'Book KOL/KOC']
      const spike_day = 4
      for (const item of extend) {
        headers.push({
          name: item,
          type: item,
          parent: ''
        })
        for (let i = 1; i <= spike_day; i++) {
          headers.push({
            name: `Spike day ${i}`,
            type: item,
            parent: item
          })
        }
        headers.push({
          name: 'Khác',
          type: item,
          parent: item
        })
      }

      const key = {
        gmv_percent: 0,
        gmv: null,
        cost_percent: 0,
        cost: null,
        order: null,
        cr: null,
        aov: null,
        traffic: null
      }

      for (const item of headers) {
        Object.assign(item, key)
      }

      // headers[0].gmv_percent = headers[0].cost_percent = 45
      // headers[4].gmv_percent = headers[4].cost_percent = 45
      // headers[7].gmv_percent = headers[7].cost_percent = 10
      //
      // if (+this.expected_gmv) {
      //   headers[0].gmv = Math.floor(+headers[0].gmv_percent * this.expected_gmv / 100)
      //   headers[4].gmv = Math.floor(+headers[4].gmv_percent * this.expected_gmv / 100)
      //   headers[7].gmv = Math.floor(+headers[7].gmv_percent * this.expected_gmv / 100)
      // }
      // if (+this.expected_cost) {
      //   headers[0].cost = Math.floor(headers[0].cost_percent * this.expected_cost / 100)
      //   headers[4].cost = Math.floor(headers[4].cost_percent * this.expected_cost / 100)
      //   headers[7].cost = Math.floor(headers[7].cost_percent * this.expected_cost / 100)
      // }

      // for (const item of headers) {
      //   if (+item.aov) item.order = Math.floor(item.gmv / item.aov)
      // }

      this.data.push(...headers)

      this.loading.generate_data = false
    }
  }
}
</script>

<style lang="scss">
.parent-row {
  background-color: #dff0d9 !important;

  td:first-child div.cell {
    font-weight: bold;
    //color: #ffffff;
  }
}

.no-hover:hover > td {
  background-color: initial !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/agency/plan_target.vue